export default {
  setNavbarTitle: (state, title) => state.navbarTitle = title,
}